/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const UnregisterDeviceBody = zod.object({
  token: zod.string().min(1).describe('Opaque push provider device token to unregister'),
});

export type UnregisterDeviceBody = zod.input<typeof UnregisterDeviceBody>;
export type UnregisterDeviceBodyOutput = zod.output<typeof UnregisterDeviceBody>;
